<script>
  export let comments;
  export let expandedComments;
  export let currentUser;
  export let group;
  export let recObject;
  export let invertedColors;
  export let mobile;
  export let viewStyle;
  export let customContext;
  export let deleteComment;
  export let reFetchRecObject;
  export let toggleReplies;

  import SingleComment from './SingleComment.svelte';
  import { browser } from '$app/environment';
  import BrowserUtils from '@utils/browser-utils';
</script>

<style lang="scss">
  @import '../../vendor/design-system.scss';

  .hidden-replies {
    margin-top: 16px;

    .hidden-comment-text {
      display: flex;
      align-items: center;
      cursor: pointer;
      padding: 12px 0;

      .icon {
        margin-right: 20px;
      }

      p {
        margin: 0;
        font-size: 14px;
        font-weight: 500;
        color: $neutral-gray;
      }
    }
  }

  .comment-replies {
    margin-left: 50px;
    // .comment-avatar {
    //   z-index: 200;
    // }
    .comment-replies-old {
      &.open {
        position: relative;
        margin-top: -28px; /* will update */
        .vector {
          display: block;
          width: 1px;
          height: calc(100% - 96px);
          position: absolute;
          left: 12px;
          top: 10px;
          background: #ececec;
          z-index: 1;
        }
        // .comment-box:first-child {
        //   margin-top: -35px; /* will update */
        // }
      }
      .vector {
        display: none;
      }
    }
  }

  .comment-wrapper {
    &.open {
      position: relative;
      padding-bottom: 30px;
      .wrapper-vector {
        display: block;
        width: 50px;
        height: calc(100% - 16px);
        position: absolute;
        left: 12px;
        top: 25px;
        border-left: 1px solid #ececec;
        border-bottom: 1px solid #ececec;
        border-bottom-left-radius: 16px;
        z-index: 1;

        &.hide-vector {
          display: none;
        }
      }
    }
    .wrapper-vector {
      display: none;
    }
  }
</style>

{#each comments as comment (comment.id)}
  <div class="comment-wrapper {expandedComments.includes(comment.id) ? 'open' : ''}">
    <span
      class="wrapper-vector {!comment.replies.some((reply) => !reply.flagged) && !comment.showHiddenReplies
        ? 'hide-vector'
        : ''}" />
    <div style="display: flex; flex-direction: column; gap: 0px;">
      <SingleComment
        comment={comment}
        currentUser={currentUser}
        deleteComment={deleteComment}
        expanded={expandedComments.includes(comment.id)}
        group={group}
        invertedColors={invertedColors}
        mobile={mobile}
        recObject={recObject}
        reFetchRecObject={reFetchRecObject}
        rootComment={true}
        toggleReplies={toggleReplies}
        viewStyle={viewStyle}
        customContext={customContext} />
      {#if browser && BrowserUtils.isIOS()}
        <input
          type="text"
          id="{comment.id}-mobile-grid-focus-input"
          style="opacity: 0; height: 0px; padding: 0px; margin: 0px; border: 0px;" />
      {/if}
    </div>
  </div>
  {#if expandedComments.includes(comment.id)}
    <div class="comment-replies">
      <div class="comment-replies-old open">
        <span class="vector" />
        {#each comment.replies.filter((reply) => !reply.flagged) as reply (reply.id)}
          <SingleComment
            comment={reply}
            rootComment={false}
            parentComment={comment}
            invertedColors={invertedColors}
            mobile={mobile}
            group={group}
            recObject={recObject}
            currentUser={currentUser}
            viewStyle={viewStyle}
            deleteComment={deleteComment}
            reFetchRecObject={reFetchRecObject}
            customContext={customContext} />
        {/each}

        {#if comment.replies.some((reply) => reply.flagged)}
          <div class="hidden-replies">
            <div
              class="hidden-comment-text"
              on:click={() => (comment.showHiddenReplies = !comment.showHiddenReplies)}
              class:hidden={comment.showHiddenReplies}>
              <img class="icon" src="/images/report/hidden-eye.svg" alt="hide-icon" />
              <p>View hidden replies</p>
            </div>

            {#if comment.showHiddenReplies}
              {#each comment.replies.filter((reply) => reply.flagged) as reply (reply.id)}
                <SingleComment
                  comment={reply}
                  rootComment={false}
                  parentComment={comment}
                  invertedColors={invertedColors}
                  mobile={mobile}
                  group={group}
                  recObject={recObject}
                  currentUser={currentUser}
                  viewStyle={viewStyle}
                  deleteComment={deleteComment}
                  reFetchRecObject={reFetchRecObject}
                  customContext={customContext} />
              {/each}
            {/if}
          </div>
        {/if}
      </div>
    </div>
  {/if}
{/each}
